import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const AmlIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1721 9.42073L9.25281 4.15627C8.72875 2.71876 8.46668 2 8.00015 2C7.53361 2 7.27155 2.71875 6.74748 4.15627L4.82811 9.42073C4.77209 9.5744 4.72694 9.79127 4.7517 9.99647C4.77074 10.1543 4.82495 10.2915 4.82936 10.2981C5.15575 10.78 6.03473 11.387 8.00015 11.387C9.96555 11.387 10.8445 10.78 11.1709 10.2981C11.1753 10.2915 11.2436 10.1194 11.2588 9.99633C11.2981 9.6778 11.2281 9.5744 11.1721 9.42073Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.66669 8C5.93897 8.30713 6.60255 8.66667 8.00002 8.66667C9.39749 8.66667 10.0611 8.30713 10.3334 8"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.33331 5.66675C6.77291 5.87085 7.32098 6.00008 7.99998 6.00008C8.67898 6.00008 9.22705 5.87085 9.66665 5.66675"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3334 9.16138L12.6224 9.74018C13.763 10.2523 14.3334 10.5084 14.3334 10.9287C14.3334 11.3491 13.763 11.6052 12.6224 12.1173L9.64082 13.456C8.83329 13.8186 8.42949 14 8.00002 14C7.57055 14 7.16675 13.8186 6.35921 13.456L3.37767 12.1173C2.23701 11.6052 1.66669 11.3491 1.66669 10.9287C1.66669 10.5084 2.23701 10.2523 3.37767 9.74018L4.66669 9.16138"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
